import { HeaderLogo } from "components";

import styles from "./LandingPageBrand.module.scss";

export interface LandingPageBrandProps {
  children?: React.ReactNode;
}

const LandingPageBrand = ({ children }: LandingPageBrandProps) => {
  return (
    <div className={styles.container}>
      <HeaderLogo className={styles.logo} />

      {children && <h1 className={styles.title}>{children}</h1>}
    </div>
  );
};

export default LandingPageBrand;
